// Module
var code = `<div class="col-lg-12">
    <bfg-chart name="retention.ChurnByStageChart"></bfg-chart>
</div>

<div class="col-lg-12">
    <bfg-chart name="retention.ChurnByMissionChart"></bfg-chart>
</div>
`;
// Exports
module.exports = code;